import React, {
    useCallback,
    useEffect,
    useRef,
    useState
} from 'react';

import { getConsentData } from '../agreementsConfig';
import {
    isConsentProvided,
    usePersonalData
} from '../hooks/usePersonalData';
import { StyledAgreementCheckbox } from '../screens/Visits/snippets/NewVisitModal/snippets';

export const ConsentCheckbox = ({
    agreementKey,
    onChange,
    profileId,
    providerCode,
    clearInitialConsent,
    containerStyle,
}) => {
    const {
        consents,
        clinics,
    } = usePersonalData();
    const initialConsent = useRef(null);
    const [ selected, setSelected ] = useState(null);

    useEffect(() => {
        // Reset the ref and state when profileId changes
        initialConsent.current = null;
        setSelected(null);
    }, [ profileId ]);

    useEffect(() => {
        if (initialConsent.current === null) {
            initialConsent.current = isConsentProvided({
                profileId,
                providerCode,
                agreementKey,
                consents,
            });
            setSelected(initialConsent.current);
        }
    }, [ consents,
        agreementKey,
        providerCode,
        profileId,
        clearInitialConsent ]);

    const onPressHandler = useCallback((d) => {
        setSelected(d);
        onChange?.(d);
    }, [ onChange ]);

    return <StyledAgreementCheckbox
        selected={selected}
        onPress={onPressHandler}
        titleComponent={getConsentData(agreementKey, clinics?.[providerCode]?.name)?.TextData}
        containerStyle={containerStyle}
        checkboxStyle={{ marginRight: 12 }}
    />;
};
